export default __webpack_public_path__ + "media/images/brands/expmessenger/backgrounds/bg-05-522c1f9539c92cf58c871b8f7920cecc.jpg";